module.exports = __webpack_public_path__ + "img/nature.a8d5d603.svg";